<template>
    <div>
        <div class="nav-container uk-position-center">
            <a href="#" class="nav left uk-position-center-left" @click.prevent="isActive--" v-if="isActive > 0"></a>
            <a href="#" class="nav right uk-position-center-right" @click.prevent="isActive++" v-if="isActive < (slides.length-1)"></a>
            <a href="#" class="nav left uk-position-center-left no-action" @click.prevent=""></a>
            <a href="#" class="nav right uk-position-center-right no-action" @click.prevent=""></a>
        </div>
        <ul class="textslider-list" uk-height-match>
            <li v-for="(slide, key) in slides" v-show="key === isActive" :key="key">
                <span v-html="slide.content"></span>
                <div class="uk-text-center">
                    <span v-html="slide.title" class="uk-text-bold"></span>
                    <span class="divider"> / </span>
                    <span v-html="slide.company"></span>
                </div>
            </li>
        </ul>

        <ul class="uk-dotnav uk-flex-nowrap uk-flex-center">
            <li v-for="(slide, key) in slides" :class="{ 'uk-active': key === isActive }" @click.prevent="isActive = key"><a href="#"></a></li>
        </ul>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                slides: null,
                isActive: 0
            }
        },
        created: function () {
            this.slides = JSON.parse(slidesString)
        },
    }
</script>